import { UserRole } from '@osc-utils/enums/user-role';

export class UserProfile {
  public id: string;
  public tenantId: string;
  public displayName: string;
  public givenName: string;
  public surname: string;
  public role: string;
  public identityProviderType: number;

  public constructor(data?: Partial<UserProfile>) {
    Object.assign(this, data ?? {});
  }

  public isAdmin(): boolean {
    return this.role?.toLowerCase() === UserRole.Admin.toLowerCase();
  }
}
